import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material';
import Colors from '../colors';
import PlusIconButton from '../components/PlusIconButton';
import { createNewDocInDb, deleteDocByCollectionAndId, getAllDocsInCollection, updateDocByCollectionAndId } from '../firebase';
import SearchBar from '../components/SearchBar';
import EditLocation from '../components/modals/EditLocation';
import LocationAccordian from '../components/modals/LocationAccordian';

function Locations({ isAdmin }) {
  const [search, setSearch] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible1, setIsVisible1] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locations, setLocations] = useState([]);
  const [filteredLocations, setFilteredLocations] = useState(locations);


  useEffect(() => {
    const fetchLocations = async () => {
      const locationsList = await getAllDocsInCollection('Locations');
      setLocations(locationsList);
    };
    fetchLocations();
  }, [isAdmin]);

  useEffect(() => {
    const filtered = locations.filter((location) => {
      const nameMatches = location?.locationName?.toLowerCase().includes(search.toLowerCase());
      return nameMatches;
    });
    setFilteredLocations(filtered);
  }, [search, locations]);


  const addLocation = async (location) => {
    const newLocation = await createNewDocInDb('Locations', location);
    setLocations([...locations, newLocation]);
  }
  const openAddLocation = () => {
    setIsVisible(true)
  }

  const updateDB = async (location) => {
    await updateDocByCollectionAndId('Locations', location.id, location);
  };

  const updateLocation = (location) => {
    const index = locations.findIndex(
      (s) => s.id === location.id
    );
    if (index !== -1) {
      const updatedLocation = [
        ...locations.slice(0, index),
        location,
        ...locations.slice(index + 1),
      ];
      setLocations(updatedLocation)
      setIsVisible1(false)
      updateDB(location)
    }
  }

  const deleteContactDB = async (location) => {
    try {
      await deleteDocByCollectionAndId('Locations', location.id);
      setLocations(locations.filter((loc) => loc.id !== location.id));
    } catch (error) {
      console.log(error);
    }
  };

  const containerStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
    paddingTop: 20,
    width: '100%'
  };

  return (
    <div style={containerStyles}>
      <SearchBar
        placeholder={'Search by Location name'}
        search={search}
        setSearch={setSearch} />
      {filteredLocations.map(location => (
          <LocationAccordian key={location.id} location={location} isAdmin={isAdmin} setIsVisible={setIsVisible1} setSelectedLocation={setSelectedLocation} />
      ))}
      {isAdmin && <div>
        <Box sx={{ position: 'fixed', bottom: '20px', right: '20px' }} >
          <PlusIconButton color={Colors.blue} onClick={openAddLocation} />
        </Box>

        {isVisible && <EditLocation isVisible={isVisible}
          setIsVisible={setIsVisible}
          title={"Add a New Location"}
          onSave={addLocation} />}
        {isVisible1 && <EditLocation isVisible={isVisible1}
          setIsVisible={setIsVisible1}
          title={"Edit Location Info"}
          onSave={updateLocation}
          location={selectedLocation}
          onDelete={deleteContactDB} />}
      </div>}
    </div>
  )
}

export default Locations;